import { SSARErrorLike } from '@ssar-app/domain';
import { Alert } from '@ssar-app/uikit';

export interface ErrorMessageForSSARErrorComponentProps {
  error: SSARErrorLike;
}
export const ErrorMessageForSSARErrorComponent = (
  props: ErrorMessageForSSARErrorComponentProps,
) => {
  const { error } = props;
  const errorDetails: string[] = [];
  if (error.details) {
    if (typeof error.details === 'string') {
      errorDetails.push(error.details);
    } else {
      error.details.forEach((a) => errorDetails.push(a));
    }
  }
  const errorDetailsNode =
    errorDetails.length === 0 ? null : errorDetails.length === 1 ? (
      <div>{errorDetails[0]}</div>
    ) : (
      <ul className='error-details'>
        {errorDetails.map((entry, index) => (
          <li key={index}>{entry}</li>
        ))}
      </ul>
    );

  return (
    <>
      <Alert
        title={error.message}
        titleProps={{ fontWeight: 'medium' }}
        description={errorDetailsNode}
        type='error'
        isOpen
        showCloseButton={false}
        showIcon={false}
      ></Alert>
      {error.id && (
        <div>
          <br />
          Request Id: {error.id}
        </div>
      )}
    </>
  );
};
